/** @jsx $jsx */
import { $jsx } from 'framework7';
export default (function () {
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page" data-name="home">
        <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner sliding">
                <div class="title">Home</div>
            </div>
        </div>
        <div class="page-content">
            <div class="container pt-2">
                <!-- MQTT status: <span id="status">Not connected</span> -->

                <div class="p-5 text-center">
                    <h5>
                        Welcome to the Sandbox App for testing the functionality of the
                        Pera-Swarm Robots & Experiments.
                    </h5>
                </div>
            </div>
        </div>
    </div>
`
    }
    ;
});